// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".splitwindow[data-v-1e8e54b7]{transition:transform .4s ease-in-out,width .4s ease-in-out,box-shadow .2s ease-in-out}.splitwindow.window-left[data-v-1e8e54b7]{width:100%}.splitwindow.window-right[data-v-1e8e54b7]{bottom:0;position:fixed;right:0;top:0;width:0;z-index:101}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
